import { render, staticRenderFns } from "./m.vue?vue&type=template&id=4fa54570&scoped=true&"
import script from "./m.vue?vue&type=script&lang=js&"
export * from "./m.vue?vue&type=script&lang=js&"
import style0 from "./m.vue?vue&type=style&index=0&id=4fa54570&prod&lang=less&"
import style1 from "./m.vue?vue&type=style&index=1&id=4fa54570&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa54570",
  null
  
)

export default component.exports